import {
  onlyNumbers,
  mediaSM,
  mediaMD,
  mediaLG,
  mediaXLG,
  scrollToHref,
  scrollToNext,
  scrollToTop
} from '../js/components/common.js';
import {
  Fullpage,
  FullpagePrimary
} from '../js/components/fullpage.js';
import bannerVideo from '../js/components/bannerVideo';
import youtubeApiInit from '../js/components/youtubeApiInit';

function cookieInfoCheck(){
    if(jQuery){
        $("#cookieInfoFooter").slideUp();
    }
    else{
        document.getElementById("cookieInfoFooter").style.display="none";
    }
    var a=new Date();
    a.setTime(a.getTime()+60*60*24*365*1000);
    document.cookie="cmsCookieInfoCheck=1; expires="+a.toGMTString()+"; path=/";
}

$(function () {

  // --------------------
  //       COMMON
  // --------------------  

  window.youtubeApiReady = false;

  youtubeApiInit(function () {
    //ready
    window.youtubeApiReady = true;
    section5hoverInit($('#section5VideoContainer'));
  });

  const fullpageInit = () => {
    let timer,
      initfullpage = false;
  
    function init() {      
      if($(window).width() >= mediaSM && initfullpage === false) {
        Fullpage('#fullpage');
        FullpagePrimary('#fullpagePrimary');
        
        initfullpage = true;
      } else if($(window).width() < mediaSM && initfullpage === true) {
        $.fn.fullpage.destroy('all');

        initfullpage = false;
      }
    }
  
    let refresh = function() {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(init, 100);
    };
  
    $(window).on('resize', function() {
      refresh();
    });
  
    init();
  }
  if($('#fullpage').length || $('#fullpagePrimary').length) fullpageInit();

  const accordion = function () {
    const $headings = $('.accordion-heading'),
      content = '.accordion-content';

    $headings.on('click', function () {
      const $this = $(this);

      $headings.not(this).removeClass('open');
      $headings.not(this).next(content).slideUp(function () {
        $(this).removeClass('open');
      });

      if ($this.hasClass('open')) {
        $this.removeClass('open');
        $this.next(content).slideUp(function () {
          $(this).removeClass('open');
        });
      } else {
        $this.addClass('open');
        $this.next(content).addClass('open').slideDown();
      }

      $.fn.fullpage.reBuild();
    });
  };
  accordion();

  const wrapTables = () => {
    $('.article-content').find('table').wrap('<div class="scroll-x-auto"></div>');
  };
  wrapTables();

  $('.hazeInfoToggle, .hazeInfo').on('click tap', function(e){e.preventDefault();if( $(this).hasClass('hazeInfo') ){$(this).toggleClass('noneHaze');}else{$(this).siblings('.hazeInfo').toggleClass('noneHaze');}});

  // --------------------
  //       HEADER
  // --------------------

  $('#searchButton').hover(function () {
    $(this).find('.search-wrapper').stop().fadeIn();
  }, function () {
    $(this).find('.search-wrapper').stop().fadeOut();
  }
  );

  const menuItemHeight = () => {
    let timer;

    const init = () => {
      $('#menu .menu-list a').each(function (index, element) {
        const $this = $(this);

        $this.css('minHeight', 0);  

        setTimeout(() => {
          $this.css('minHeight', $this.parent('li').height());            
        }, 500);
      });
    }

    init();

    var refresh = function () {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(init, 100);
    };

    $(window).resize(function () {
      refresh();
    });
  }
  menuItemHeight();


  // --------------------
  //       MENU
  // --------------------

  function openSubmenu(that) {
    let $this = $(that),
      $firstSubmenu = $this.find('>.submenu');

    $firstSubmenu.stop().fadeIn();
   
    if ($this.find('>.submenu-1').length) {
      $('#menu .menu-bg-2').stop().fadeIn(600);
    }
  }

  $('#menu .menu-list li').on('mouseenter', function() {
    if($(window).width() >= mediaSM) {
      const that = this;
  
      openSubmenu(that);
    }
  });

  $('#menu .menu-list li').on('click', function() {
    if($(window).width() < mediaSM) {
      const that = this;
  
      openSubmenu(that);
    }
  });

  $('#menu .menu-list a').on('click', function (e) {
    let $this = $(this),
      $firstSubmenu = $this.parent().find('>.submenu');

    if ($firstSubmenu.length) {
      if($(window).width() < mediaSM) {
        e.preventDefault();
      }      
    }
  });  

  $('#menu .menu-list li').on('mouseleave', function () {
    let $this = $(this);

    $this.find('>.submenu').stop().fadeOut();

    if ($this.find('>.submenu-1').length) {
      $('#menu .menu-bg-2').stop().fadeOut(200);
    }
  });

  $('.menu-back').on('click', function (e) {
    e.stopPropagation();

    $(this).parent().fadeOut();
  });

  $('#btn-menu').on('click', function () {
    let $this = $(this);

    $this.blur();
    $this.parent().toggleClass('open');
  });

  $('#btn-menu-xs').on('click', function () {
    let $this = $(this);

    $this.blur();
    $('#menu').toggleClass('open');
    $('body').toggleClass('menu-xs-open');
  });

  $('#menu>.bg, #close-menu-btn').on('click', function () {
    $('#menu').removeClass('open');
    $('body').removeClass('menu-xs-open');
  });


  // --------------------
  //       SECTION-1
  // --------------------  

  $('.arrow-bottom').on('click', function () {
    $.fn.fullpage.moveSectionDown();
  });

  bannerVideo($('#banner-carousel'));

  const bannerCarousel = (function () {
    const $carousel = $('#banner-carousel');

    $carousel.slick({
      dots: true,
      arrows: false,
      pauseOnHover: false,
      autoplay: $carousel.data('autoplay'),
      autoplaySpeed: $carousel.data('autoplayspeed')
    });
  })();


  // --------------------
  //       SECTION-2
  // -------------------- 

  const $newsBoxCarousel = $('#news-box-carousel'),
    $calendarBoxCarousel = $('#calendar-box-carousel'),
    $trainingsBoxCarousel = $('#trainings-box-carousel');
 
  $calendarBoxCarousel.on('init', function() {
    $($calendarBoxCarousel)
      // .add($trainingsBoxCarousel)
      .find('.excerpt').linesLimit({
        lines: 2,
        wMin: 1200
    });
  });

  $($newsBoxCarousel)
    .add($calendarBoxCarousel)
    .add($trainingsBoxCarousel)
    .slick({
      dots: true,
      arrows: false
    });

  $newsBoxCarousel.parent().find('.btn-next').on('click', function () {
    $newsBoxCarousel.slick('slickNext');
  });

  $calendarBoxCarousel.parent().find('.btn-next').on('click', function () {
    $calendarBoxCarousel.slick('slickNext');
  });

  $trainingsBoxCarousel.parent().find('.btn-next').on('click', function () {
    $trainingsBoxCarousel.slick('slickNext');
  });  


  // --------------------
  //       SECTION-3
  // -------------------- 

  $('#videoContainer').slickCustom({
    min: 0,
    max: 768,
    slickSettings: {
      arrows: false,
      dots: true,
      autoplay: true
    }
  });


  // --------------------
  //       SECTION-4
  // --------------------

  const $section4Carousel = $('#section-4-carousel'),
    $section4NewsCarousel = $('#section-4-news-carousel'),
    $section4SaleCarousel = $('#section-4-sale-carousel');

  $($section4Carousel)
    .slick({
      dots: false,
      arrows: false,
      swipe: false,
      initialSlide: 1
    });

  $($section4NewsCarousel)
    .add($section4SaleCarousel)
    .slick({
      dots: true,
      arrows: false,
      pauseOnHover: false
    });

  $('.carousel-link-sale').on('click', function (e) {
    e.preventDefault();

    $section4Carousel.slick('slickGoTo', 0);
  });

  $('.carousel-link-news').on('click', function (e) {
    e.preventDefault();

    $section4Carousel.slick('slickGoTo', 1);
  });  

  // --------------------
  //       SECTION-5
  // -------------------- 

  const $section5VideoContainer = $('#section5VideoContainer');

  const section5Video = (() => {
    const $videoFiles = $section5VideoContainer.find('video.play-hover').parent('.item');

    $videoFiles.hover(function (e) {
      let vid = $(this).find('video')[0];

      vid.play();
    }, function () {
      let vid = $(this).find('video')[0];

      vid.pause();
      vid.currentTime = 0;
    });
  })();

  function section5hoverInit($section5VideoContainer) {
    const $videoIframesFiles = $section5VideoContainer.find('.video-iframe-hover').parent().parent('.item');

    let currentVideo;

    $videoIframesFiles.hover(function () {
      let iframe = $(this).find('iframe').prop('id'),
        vid;

      youTubePlayers.forEach(function (e, i) {
        if (e.a.id === iframe) {
          currentVideo = e;
          e.mute();
          e.playVideo();
        }
      })
    }, function () {
      currentVideo.stopVideo();
    }
    );
  }

  $('#section5carousel-xs').slickCustom({
    min: 0,
    max: 768,
    slickSettings: {
      arrows: false,
      dots: true,
      autoplay: true
    }
  });


  // --------------------
  //       SECTION-6
  // -------------------- 

  const $aboutUsCarousel = $('#about-us-carousel');

  $aboutUsCarousel.slick({
    arrows: false,
    dots: true
  });

  $aboutUsCarousel.find('.btn--arrow').on('click', function (e) {
    e.preventDefault();

    $aboutUsCarousel.slick('slickNext');
  });

  $aboutUsCarousel.find('.btn-arrow-xs').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $aboutUsCarousel.slick('slickNext');
  });

  $('.section-6 .row .descr').linesLimit2({
    lines: 2,
    wMin: 1200
  });


  // --------------------
  //       SECTION-7
  // -------------------- 

  $('#section-7-banner .descr').linesLimit({
    wMax: mediaMD,
    lines: 3
  });

  $('#section7carousel-xs').slickCustom({
    min: 0,
    max: 768,
    slickSettings: {
      arrows: false,
      dots: true,
      autoplay: true
    },
    onInit: function() {
      $('#section7carousel-xs .descr').linesLimit({
        wMax: mediaSM,
        lines: 6
      }); 
    }
  });

  // --------------------
  //       ACADEMY
  // -------------------- 

  function academyCalendar() {
    function createEvents(eventsContainer) {
      let eventsData = [];

      $(eventsContainer).find('.calendar-event').each(function (index, element) {
        let eventDate = $(element).data('date');

        eventsData.push({ date: eventDate });
      });

      return eventsData;
    }

    function myDateFunction(id) {
      let date = $("#" + id).data('date'),
        events = $('#calendar-events-wrapper .calendar-event');

      if ($('#' + id).data('hasEvent')) {
        events.hide();

        events.each(function (index, element) {
          if ($(element).data('date') === date) {
            $('#calendar-events-wrapper .event-select').hide();
            $(element).show();
            $(element).find('.carousel').slick('setPosition');
            $('.calendar-carousel .title').linesLimit({
              lines: 3,
              wMin: 1200,
              wMax: 1900
            });
            $('.calendar-carousel .descr p').linesLimit({
              lines: 4,
              wMin: 1200,
              wMax: 1900
            });
          }
        });
      }
    }

    $('section.academy .col-content .text p').linesLimit({
      lines: 8,
      wMin: 1200,
      wMax: 1900
    });

    $('section.academy .col-content .text p').linesLimit({
      lines: 12,
      wMin: 1024,
      wMax: 1199
    });

    $('section.academy .col-content .text p').linesLimit({
      lines: 7,
      wMin: 768,
      wMax: 1023
    });

    $('#calendar-events-wrapper .calendar-carousel').slick({
      arrows: false,
      dots: true
    });

    $("#calendar-academy").zabuto_calendar({
      language: $(".calendar").data('lang'),
      data: createEvents('#calendar-events-wrapper'),
      action: function () {
        return myDateFunction(this.id);
      }
    });
  }
  academyCalendar();


  // --------------------
  //   CALENDAR-EVENTS
  // -------------------- 

  function eventsCalendar() {
    function createEvents(eventsContainer) {
      let eventsData = [];

      $(eventsContainer).find('.calendar-event').each(function (index, element) {
        let eventDate = $(element).text();

        eventsData.push({ date: eventDate });
      });

      return eventsData;
    }

    function myDateFunction(id, eventsContainer) {
      let $event = $('#' + id),
        eventDate = $event.data('date');

      if ($event.data('hasEvent')) {
        $(eventsContainer).find('.calendar-event').each(function (index, element) {
          let linkDate = $(element).text();

          if (linkDate === eventDate) {
            let link = $(element).attr('href');

            window.open(link, '_self');
          }
        });
      }
    }

    $("#calendar-events").zabuto_calendar({
      language: $(".calendar").data('lang'),
      data: createEvents('#calendar-events-wrapper'),
      action: function () {
        return myDateFunction(this.id, '#calendar-events-wrapper');
      }
    });
  }
  eventsCalendar();


  // --------------------
  //    NEWS-DETAILS
  // --------------------

  bannerVideo($('#news-details-for'));

  $('#news-details-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '#news-details-nav'
  });

  $('#news-details-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '#news-details-for',
    dots: false,
    arrows: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });


  // --------------------
  //        BLOG
  // --------------------

  window.blogLinesLimit = function() {
    $('section.blog .articles-top .col-1 .excerpt').linesLimit({
      wMin: 768,
      lines: 4
    });
  
    $('section.blog .articles-top .col-2 .excerpt').linesLimit({
      wMin: 768,
      lines: 2
    });
  
    $('section.blog .articles-bottom .excerpt-lg').linesLimit({
      wMin: 1200,
      lines: 3
    });
  }
  blogLinesLimit();

  const articleCarouselXS = function () {
    $('#articles-top').find('.blog-article').clone().appendTo('#articles-top-carousel');

    $('#articles-top-carousel').slick({
      arrows: false,
      dots: true
    });
  };
  articleCarouselXS();

  const sidebarCollapse = function () {
    if ($('#sidebar-xs').length) {
      $('#sidebar').clone().appendTo('#sidebar-xs');

      const $headings = $('#sidebar-xs .heading');

      $headings.on('click', function () {
        const $this = $(this);

        $headings.not(this).removeClass('open');
        $headings.next('ul').not(this).slideUp();

        if ($this.hasClass('open')) {
          $this.removeClass('open');
          $this.next('ul').slideUp();
        } else {
          $this.addClass('open');
          $this.next('ul').slideDown();
        }
      });
    }
  };
  sidebarCollapse();

  $('#products-preview-carousel').slickCustom({
    min: 0,
    max: 768,
    slickSettings: {
      arrows: false,
      dots: true
    }
  });


  // --------------------
  //      MISSION
  // --------------------

  const $missionCarousel = $('#mission-carousel'),
    $missionDots = $missionCarousel.find('.mission-dots');

  function missionCloneDots() {
    $('#mission-dots-container .slick-dots').clone(true, true).appendTo($missionDots);
  }

  $missionCarousel.on('init', function () {
    missionCloneDots();
  });

  $missionCarousel.slick({
    arrows: false,
    dots: true,
    appendDots: '#mission-dots-container',
    accessibility: false
  });

  $missionCarousel.on('afterChange', function () {
    $missionDots.empty();
    missionCloneDots();
  });

  $('.mission-arrow-prev').on('click', function () {
    $missionCarousel.slick('slickPrev');
  });

  $('.mission-arrow-next').on('click', function () {
    $missionCarousel.slick('slickNext');
  });


  // --------------------
  //    PRIMULATOR TV
  // --------------------

  const galleryTooltip = (function () {
    const $tooltipWrapper = $('.gallery-tooltip');

    $tooltipWrapper.on('mousemove', function (e) {
      const $tooltip = $(this).find('.tooltip-content'),
        x = (e.offsetX + 20) + 'px',
        y = (e.offsetY + 20) + 'px';

      $tooltip.css({
        'top': y,
        'left': x
      });
    });
  })();


  // --------------------
  //      CONTACT
  // --------------------

  if($(window).width() > mediaLG && $(window).height() < 900 ) {
    $('.section.contact .map-wrapper').css('maxWidth', 650);
  }

  function mergeRegions(el, action) {
    var elClass = el.attr("class").split(" ")[0];
    var regions = $mapCountry.data('regions') ? $mapCountry.data('regions').split(';') : [];

    if (regions.length > 0) {
      $.each(regions, function (index, value) {
        var regions2 = value.split(',');
        var indexOfElement = regions2.indexOf(elClass);
        if (indexOfElement != -1) {
          $.each(regions2, function (index2, value2) {
            switch (action) {
              case "hover": $mapCountry.find('li.' + value2).addClass("focus"); break;
              case "unHover": $mapCountry.find('li.' + value2).removeClass("focus"); break;
              /*case "click": $mapCountry.find('li').removeClass("active-region"); break;*/
              case "click": $mapCountry.find('li.' + value2).addClass("active-region"); break;
            }
          });
          return false;
        }
      });
    }
  }; // END function mergeRegions();

  const $mapCountry = $('#map-country'),
    $mapEurope = $('#map-europe');

  if ($mapCountry.length) {
    const activateOnLoad = $mapCountry.data('activateonload') ? $mapCountry.data('activateonload').split(',') : [],
      loadingText = $mapCountry.data('loadingtext');

    $mapCountry.CSSMap({
      "size": 650, /*  */
      "mapStyle": "default",
      "tooltips": "floating-top-center",
      "responsive": "auto",
      activateOnLoad: activateOnLoad,
      loadingText: loadingText,
      onHover: function (e) { mergeRegions(e, "hover"); },
      unHover: function (e) { mergeRegions(e, "unHover"); },
      onClick: function (e) { mergeRegions(e, "click"); 
                                var $e_class = e.attr("class").split(" ")[0];
                                if($('.voivodeships-menu .' + $e_class).length){
                                    $('.voivodeships-menu .' + $e_class).click();
                                }else{
                                    $('.voivodeships-menu .__'+ $e_class).click();
                                }
                            },
      onSecondClick: function (e) { mergeRegions(e, "click"); 
                                        var $e_class = e.attr("class").split(" ")[0];
                                        if($('.voivodeships-menu .' + $e_class).length){
                                            $('.voivodeships-menu .' + $e_class).click();
                                        }else{
                                            $('.voivodeships-menu .__'+ $e_class).click();
                                        }
                                    },
      onLoad: function (m) { mergeRegions($('.voivodeships-menu .' + m.data('activateonload')), "click"); }
    });
  }

  if ($mapEurope.length) {
    const activateOnLoad = $mapEurope.data('activateonload') ? $mapEurope.data('activateonload').split(',') : [],
      loadingText = $mapEurope.data('loadingtext');

    $mapEurope.CSSMap({
      "size": 650, /*  */
      "mapStyle": "default",
      "tooltips": "floating-top-center",
      "responsive": "auto",
      activateOnLoad: activateOnLoad,
      loadingText: loadingText,
      onSecondClick: function (e) {
        $('.voivodeships-menu .' + e.attr("class").split(" ")[0]).click();
        $mapEurope.find('li').addClass('active-region');
      },
      onClick: function (e) {
        $('.voivodeships-menu .' + e.attr("class").split(" ")[0]).click();
        $mapEurope.find('li').addClass('active-region');
      }
    });
  }

  $('.voivodeships-menu .voivodeship-item').on('click', function () {
    $('.voivodeships-menu .voivodeship-item').removeClass('underline');
    $(this).addClass('underline');
    if ($mapCountry.length) {
      $mapCountry.find('li').removeClass("active-region");
      mergeRegions($(this), "click");
    }
  });  

  // --------------------
  //     COMPARISON
  // --------------------

  const seminarsArrowsMobile = function () {
    let $tableWrapper = $('#products-table-wrapper');

    function toggleArrows(leftPos) {
      if (leftPos > 0) {
        $tableWrapper.find(".btn-right").hide();
        $tableWrapper.find(".btn-left").show();
      } else {
        $tableWrapper.find(".btn-left").hide();
        $tableWrapper.find(".btn-right").show();
      }
    }

    $tableWrapper.on('scroll', function () {
      let leftPos = $(this).scrollLeft();

      toggleArrows(leftPos);
    });

    $tableWrapper.find(".btn-left").click(function () {
      var leftPos = $tableWrapper.scrollLeft();
      $tableWrapper.animate({
        scrollLeft: leftPos - 400
      }, 800);
    });

    $tableWrapper.find(".btn-right").click(function () {
      var leftPos = $tableWrapper.scrollLeft();
      $tableWrapper.animate({
        scrollLeft: leftPos + 400
      }, 800);
    });
  }();


  // --------------------
  //   SINGLE-PRODUCER
  // --------------------

  const $producerProducts = $('#producer-products'),
    $productsMenu = $producerProducts.find('.products-menu');

  $productsMenu.slick({
    dots: false,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: false,
    responsive: [
      {
        breakpoint: mediaSM,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false
        }
      }
    ]
  });

  $producerProducts.find('.arrow-left').on('click', function () {
    $productsMenu.slick('slickPrev');
  });

  $producerProducts.find('.arrow-right').on('click', function () {
    $productsMenu.slick('slickNext');
  });

  // --------------------
  //   SIMPLE-PAGE PAGE-BANNER-MENU
  // --------------------

  const $pageBannerContainer = $('#page-banner-container'),
    $pageBannerMenu = $pageBannerContainer.find('#page-banner-menu');

  $pageBannerMenu.slick({
    dots: false,
    arrows: false,
    slidesToShow: 9,
    slidesToScroll: 9,
    initialSlide: $("#page-banner-menu .active").length ? $("#page-banner-menu .active").index() : 0,
    variableWidth: true,
    responsive: [
      {
        breakpoint: mediaSM,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false
        }
      }
    ]
  });

  $pageBannerContainer.find('.arrow-left').on('click', function () {
    $pageBannerMenu.slick('slickPrev');
  });

  $pageBannerContainer.find('.arrow-right').on('click', function () {
    $pageBannerMenu.slick('slickNext');
  });


  // ----------------------
  //  PRODUCTS-SUBCATEGORY
  // ----------------------

  // $(".products-subcategory .col-right").mCustomScrollbar({
  //   theme: "red",
  //   axis: "x"
  // });


  // --------------------
  //      PRODUCT
  // --------------------

  //product-menu
  $('.productMenu').each(function (index, element) {
    const $element = $(element);

    $element.on('click', 'a', function(e) {
      e.preventDefault();

      const $this = $(this);

      const sectionIndex = $($this.attr('href')).index() + 1;
      $.fn.fullpage.moveTo(sectionIndex);
    });
  });

  //product-start
  window.productImgCarousel = function () {
    $('.product-img-carousel').slick({
      arrows: true,
      dots: true
    });
  }

  productImgCarousel();

  $('#product-menu-xs').on('change', function () {
    $(this).selectric('refresh');
  });

  //product-video
  bannerVideo($('#product-video-carousel'));

  $('#product-video-carousel').slick({
    arrows: true,
    dots: true
  });

  //product-specification
  $('.product-specification-download').slick({
    arrows: false,
    dots: true
  });

  const hideScrollbar = (() => {
    $(window).on('load', function () {
      const $productSpecification = $('.product-specification'),
        $table2 = $productSpecification.find('.table-2'),
        $tableContent = $table2.find('table'),
        $scrollbar = $productSpecification.find('#mCSB_1_scrollbar_horizontal');
  
      if($tableContent.width() <= $table2.width()) {
        $scrollbar.css('visibility', 'hidden');
      }      
    });
  })();

  //product-sets
  window.productSetsCarousel = function() {
    $('#product-sets-carousel').slick({
      dots: true,
      arrows: true
    });
  }

  productSetsCarousel();

  //product-accessories
  $('#product-accessories-carousel').slick({
    dots: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    // rows: 2,
    appendArrows: $('#product-accessories-controls'),
    appendDots: $('#product-accessories-controls'),
    responsive: [
      {
        breakpoint: mediaMD,
        settings: {
          // rows: 2,
          slidesPerRow: 2,
          slidesToShow: 1,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: mediaSM,
        settings: {
          rows: 1,
          slidesPerRow: 1,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('#product-accessories-carousel-2').slickCustom({
    slickSettings: {
      dots: true,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      appendArrows: $('#product-accessories-2-controls'),
      appendDots: $('#product-accessories-2-controls')
    }
  });

  //product-features
  $('#product-features-carousel').slick({
    dots: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    appendArrows: $('#product-features-controls'),
    appendDots: $('#product-features-dots'),
    responsive: [
      {
        breakpoint: mediaMD,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          slidesToShow: 1,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: mediaSM,
        settings: {
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  //product-bookmarks  
  $('#product-bookmarks-menu a').on('click', function (e) {
    e.preventDefault();

    const $this = $(this);

    $('#product-bookmarks-menu a').not(this).removeClass('underline');

    if(!$this.hasClass('underline')) {
      $this.tab('show');
      $this.addClass('underline');
    }
  }).on('shown.bs.tab', function () { 
    $.fn.fullpage.reBuild();    
  });  

  $('#product-bookmarks-menu-xs').slickCustom({
    slickSettings: {
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      asNavFor: '#product-bookmarks-content-xs',
    }
  });

  $('#product-bookmarks-content-xs').slickCustom({
    slickSettings: {
      dots: false,
      arrows: false,
      adaptiveHeight: true,
      asNavFor: '#product-bookmarks-menu-xs',
    }
  });  

});


// WEBPACK FOOTER //
// ./src/js/main.js